import GLightbox from "glightbox"

export const setupGallery = () => {
  GLightbox({
    openEffect: "zoom",
    closeEffect: "none",
    selector: ".act-as-lightbox",
  })
}
